module.exports = __webpack_public_path__ + "static/media/120.b7f628da.jpg";